export default {
  DEFAULT: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication including information on exclusive offers and new services. See our Privacy Notice to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "#",
    privacy_policy_link: "#",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Notice",
    optInSuffix: " to learn more."
  },
  GSO: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Piedmont Triad International Airport including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "/terms.html",
    privacy_policy_link: "/privacy.html",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Piedmont Triad International Airport including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  ST1: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://res.cloudinary.com/rezcomm2018/image/upload/v1787046789/abm/STL_Terms.pdf",
    privacy_policy_link: "https://www.abm.com/privacy-policy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  FM1: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Flughafen Memmingen GmbH including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://www.memmingen-airport.com/parking-terms-and-conditions",
    privacy_policy_link: "https://www.memmingen-airport.com/privacy-policy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Flughafen Memmingen GmbH including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  FMM: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "",
    loyaltyMember: "",
    unlockPerks: "",
    redeemPoints: "",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Flughafen Memmingen GmbH including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://www.memmingen-airport.com/parking-terms-and-conditions",
    privacy_policy_link: "https://www.memmingen-airport.com/privacy-policy",
    acceptTermsPrefix: "* Click here to accept",
    acceptTermsSuffix: "which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Flughafen Memmingen GmbH including information on exclusive offers and new services. See our",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: "to learn more."
  },
  HVN: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Tweed-New Haven Airport including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://flytweed.com/terms-and-conditions",
    privacy_policy_link: "https://flytweed.com/privacy-policy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Tweed-New Haven Airport including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  INV: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Inverness Airport including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://invernessairport.com/terms-and-conditions",
    privacy_policy_link: "https://invernessairport.com/privacy-policy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Inverness Airport including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  IP1: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from iPark Glasgow including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "#",
    privacy_policy_link: "/privacy.html",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from iPark Glasgow including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  LDY: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from City of Derry Airport including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://cityofderryairport.com/terms-and-conditions",
    privacy_policy_link: "https://cityofderryairport.com/privacy-policy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from City of Derry Airport including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  ML1: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from MDL Marinas including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://mdlmarinas.co.uk/terms-and-conditions",
    privacy_policy_link: "#",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from MDL Marinas including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  NOC: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Ireland West Airport including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://irelandwestairport.com/terms-and-conditions",
    privacy_policy_link: "https://irelandwestairport.com/privacy-policy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Ireland West Airport including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  NQY: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Cornwall Airport Newquay including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://cornwallairportnewquay.com/terms-and-conditions",
    privacy_policy_link: "https://cornwallairportnewquay.com/privacy-policy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Cornwall Airport Newquay including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  PIT: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from PIT including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://pitstaging.rezcomm.com/terms.html",
    privacy_policy_link: "#",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from PIT including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  SZG: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Salzburg Airport including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://www.salzburg-airport.com/parken/einstellbedingungen",
    privacy_policy_link: "https://www.salzburg-airport.com/footer/legal/datenschutz",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Salzburg Airport including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  
  LAX: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings, earn points on parking, redeem points for discounts, and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter the email address you used to retrieve your key documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-In to receive communication from Los Angeles World Airports including information on exclusive offers and new services. Visit our Privacy Notice to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to (email address).",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "We recommend you register this device for faster logins & best in class security. To register a passkey, you must first verify your email ownership.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    // Additional passkey/registration text for full coverage
    passkeyInfo: "We recommend you register this device for faster logins & best in class security. To register a passkey, you must first verify your email ownership.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://landinglax.rezcommdev.com/lax/lax-terms-and-conditions.html",
    privacy_policy_link: "https://www.flylax.com/legal",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-In to receive communication from Los Angeles World Airports including information on exclusive offers and new services. Visit our ",
    privacyNoticeLinkText: "Privacy Notice",
    optInSuffix: " to learn more."
  },
  YHM: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Hamilton International including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://flyhamilton.ca/terms.html",
    privacy_policy_link: "https://flyhamilton.ca/privacy-policy/",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Hamilton International including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  SV1: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Summit including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://www.summitairportparking.com/legal/terms",
    privacy_policy_link: "https://www.summitairportparking.com/legal/privacy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Summit including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  RDU: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from RDU including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://booking.rdu.com/terms.html",
    privacy_policy_link: "https://www.rdu.com/privacy/",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from RDU including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  RSW: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from RSW including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://rswstaging.rezcomm.com/terms.html",
    privacy_policy_link: "https://rswstaging.rezcomm.com/privacy.html",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from RSW including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  PV1: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from PVD Airpark including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://stage.pvdairpark.com/terms",
    privacy_policy_link: "https://stage.pvdairpark.com/privacy",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from PVD Airpark including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  HER: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Hermes Airports including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://www.hermesairports.com/terms-and-conditions-of-use",
    privacy_policy_link: "https://www.hermesairports.com/privacy-notice",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Hermes Airports including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  NWI: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Norwich Airport including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://www.norwichairport.co.uk/terms-of-use/",
    privacy_policy_link: "https://www.norwichairport.co.uk/privacy-policy/",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Norwich Airport including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  JER: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from Jersey Airport including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://www.jerseyairport.com/terms-and-conditions",
    privacy_policy_link: "https://www.jerseyairport.com/privacynotice",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from Jersey Airport including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  PB1: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from PBW including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "https://pbw.de/?menu=rechtliches",
    privacy_policy_link: "https://pbw.de/?menu=rechtliches",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from PBW including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  NUE: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "Create an account to:",
    loyaltyMember: "Join as a Loyalty Member",
    unlockPerks: "Unlock exclusive perks",
    redeemPoints: "Redeem points for savings on future bookings",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from PBW including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "/terms.html",
    privacy_policy_link: "https://www.airport-nuernberg.de/de/datenschutz",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I opt-in to receive communication from PBW including information on exclusive offers and new services. See our ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: " to learn more."
  },
  SB2: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "",
    loyaltyMember: "",
    unlockPerks: "",
    redeemPoints: "",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from PBW including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "/terms.html",
    privacy_policy_link: "https://stpancras-highspeed.com/privacy-policy/",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I consent to receive marketing communications by email from London St Pancras Highspeed, including newsletters, discounts, and offers relating to travel services and station activities. I understand my personal data will be processed in accordance with the ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: ", and that I can unsubscribe at any time."
  },
  SB3: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "",
    loyaltyMember: "",
    unlockPerks: "",
    redeemPoints: "",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from PBW including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "/terms.html",
    privacy_policy_link: "https://stpancras-highspeed.com/privacy-policy/",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I consent to receive marketing communications by email from London St Pancras Highspeed, including newsletters, discounts, and offers relating to travel services and station activities. I understand my personal data will be processed in accordance with the ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: ", and that I can unsubscribe at any time."
  },
  SB4: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "",
    loyaltyMember: "",
    unlockPerks: "",
    redeemPoints: "",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from PBW including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "/terms.html",
    privacy_policy_link: "https://stpancras-highspeed.com/privacy-policy/",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I consent to receive marketing communications by email from London St Pancras Highspeed, including newsletters, discounts, and offers relating to travel services and station activities. I understand my personal data will be processed in accordance with the ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: ", and that I can unsubscribe at any time."
  },
  SB5: {
    signIn: "Sign In",
    createAccount: "Create Account",
    signInIntro: "Sign in for easier bookings and manage your bookings anytime.",
    guestBookingInfo: "If you made a booking as a guest, enter your email address to retrieve your documents.",
    emailAddress: "Email Address",
    chooseOtpMethod: "Choose how to receive your verification code",
    sendToEmail: "Send to Email",
    sendToMobile: "Send to Mobile",
    checking: "Checking...",
    signInButton: "Sign In",
    createAccountButton: "Create Account",
    createAccountIntro: "",
    loyaltyMember: "",
    unlockPerks: "",
    redeemPoints: "",
    yourDetails: "Your Details",
    firstName: "First Name",
    lastName: "Last Name",
    noPassword: "No password required. Quicker sign-in, no hassle!",
    termsAndConditions: "Terms & Conditions",
    privacyNotice: "Privacy Notice",
    optIn: "I opt-in to receive communication from PBW including information on exclusive offers and new services. See our Privacy Policy to learn more.",
    creatingAccount: "Creating Account...",
    verificationSent: "We've sent a 6 digit verification code to your email address.",
    didNotGetCode: "Did not get code?",
    tryAgain: "Try again",
    continueOnPhone: "Continue on your phone to auto-fill the code",
    continueOnPhoneBtn: "Continue on Phone",
    signingIn: "Signing In...",
    passkey: "Register this device for faster logins & best security. You must verify your email first.",
    pleaseVerifyEmail: "Please verify this email address to register your passkey",
    sendVerificationCode: "Send Verification Code",
    enterVerificationCode: "Enter the verification code sent to your email",
    verifyCode: "Verify Code",
    emailVerificationSuccess: "Email verification successful! You can now proceed with passkey registration.",
    registrationSuccess: "Registration Successful!",
    passkeyRegistered: "Your passkey has been registered successfully.",
    continue: "Continue",
    skipForNow: "Skip for now",
    backToLogin: "Back to Login",
    passkeyInfo: "Register this device for faster logins & best security. You must verify your email first.",
    registrationSuccessTitle: "Registration Successful!",
    registrationSuccessMessage: "Your passkey has been registered successfully.",
    terms_and_conditions_link: "/terms.html",
    privacy_policy_link: "https://stpancras-highspeed.com/privacy-policy/",
    acceptTermsPrefix: "* Click here to accept ",
    acceptTermsSuffix: " which includes privacy information as to data collection and usage.",
    optInPrefix: "I consent to receive marketing communications by email from London St Pancras Highspeed, including newsletters, discounts, and offers relating to travel services and station activities. I understand my personal data will be processed in accordance with the ",
    privacyNoticeLinkText: "Privacy Policy",
    optInSuffix: ", and that I can unsubscribe at any time."
  }
};